export enum ClientTableColumns {
  name = "name",
  domain = "domain",
  email = "email",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  description = "description",
}

export const CLIENT_TABLE_COLUMN_LABELS: Record<ClientTableColumns, string> = {
  [ClientTableColumns.name]: "Name",
  [ClientTableColumns.domain]: "Domain",
  [ClientTableColumns.email]: "Email",
  [ClientTableColumns.createdAt]: "Created",
  [ClientTableColumns.updatedAt]: "Updated",
  [ClientTableColumns.description]: "Description",
};

export const DEFAULT_CLIENT_TABLE_COLUMN_SETTINGS: Record<
  ClientTableColumns,
  boolean
> = {
  [ClientTableColumns.name]: true,
  [ClientTableColumns.domain]: true,
  [ClientTableColumns.email]: true,
  [ClientTableColumns.createdAt]: true,
  [ClientTableColumns.updatedAt]: false,
  [ClientTableColumns.description]: false,
};

export const DEFAULT_CLIENT_TABLE_COLUMN_ORDER: ClientTableColumns[] = [
  ClientTableColumns.name,
  ClientTableColumns.domain,
  ClientTableColumns.email,
  ClientTableColumns.createdAt,
  ClientTableColumns.updatedAt,
  ClientTableColumns.description,
];

// Helper functions to generate derived data
export const getColumnLabels = (): Record<string, string> =>
  CLIENT_TABLE_COLUMN_LABELS;
export const getDefaultColumnSettings = (): Record<string, boolean> =>
  DEFAULT_CLIENT_TABLE_COLUMN_SETTINGS;
export const getDefaultColumnOrder = (): string[] =>
  DEFAULT_CLIENT_TABLE_COLUMN_ORDER;
